import React from 'react';

// Without this, any uncaught render error (a bad chart data shape, an unexpected API response,
// etc.) unmounts the entire React tree and leaves only the page's background color visible —
// a blank/black screen with no indication anything went wrong. This catches that and shows a
// recoverable message instead.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Uncaught render error:', error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="app-loading" style={{ flexDirection: 'column', gap: 16, textAlign: 'center', padding: 24 }}>
          <p style={{ fontSize: 16, color: 'var(--text-primary)' }}>Something went wrong loading this page.</p>
          <p style={{ maxWidth: 480, color: 'var(--text-secondary)' }}>{this.state.error.message}</p>
          <button className="secondary-button" onClick={() => window.location.reload()}>
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
